import Vue from "vue";
import img from "@/components/img.vue";

Vue.component("v-img", img);
